import ShDividerLine from '@/components/Helpers/ShDividerLine';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import UserListItem from './UsersListItem';

// @vue/component
export default {
  name: 'UsersList',

  components: {
    ShDividerLine,
    AddNewElementButton,
    UserListItem,
  },

  computed: {
    possibleNumberOfUsersAccordingToAccessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'].global_options.number_of_users;
    },
    usersList() {
      return this.$store.getters['users/list'].map(user => ({
        ...user,
        isAddedToCallwebPlatform: Object.keys(user.profile).length !== 0,
      }));
    },
    usersAddedToCallweb() {
      return this.usersList.filter(user => user.isAddedToCallwebPlatform);
    },
    usersInOtherPlatforms() {
      return this.usersList.filter(user => !user.isAddedToCallwebPlatform);
    },
    isWaitingForUsersList() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'users/getList', 'users/delete',
      ]);
    },
  },

  created() {
    this.$store.dispatch('users/getList');
  },

  methods: {
    handleCreateNewUser() {
      this.$EventBus.$emit('SHOW_USER_PROFILE', { user: {}, shouldRefreshList: true });
    },
  },
};
